var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "internal-login" }, [
    _c("section", { staticClass: "login-panel" }, [
      _vm._m(0),
      _c(
        "form",
        {
          staticClass: "login-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleLogin.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { staticClass: "field" }, [
            _c("span", [_vm._v("账号")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.form.username,
                  expression: "form.username",
                  modifiers: { trim: true },
                },
              ],
              attrs: {
                autocomplete: "username",
                name: "username",
                placeholder: "请输入账号",
                type: "text",
              },
              domProps: { value: _vm.form.username },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "username", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]),
          _c("label", { staticClass: "field" }, [
            _c("span", [_vm._v("密码")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.password,
                  expression: "form.password",
                },
              ],
              attrs: {
                autocomplete: "current-password",
                name: "password",
                placeholder: "请输入密码",
                type: "password",
              },
              domProps: { value: _vm.form.password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "password", $event.target.value)
                },
              },
            }),
          ]),
          _vm.errorMessage
            ? _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "submit-button",
              attrs: { disabled: _vm.isSubmitting, type: "submit" },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.isSubmitting ? "登录中..." : "登录") + " "
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-header" }, [
      _c("p", { staticClass: "login-kicker" }, [_vm._v("KJCSGO")]),
      _c("h1", [_vm._v("内部登录")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }